import api from "./axios";


// ============================================================
// LIST JOURNEY PLANS
// ============================================================

export const getJourneyPlans = (
    page = 1,
    limit = 10,
    params = {}
) => {

    /*
    |--------------------------------------------------------------------------
    | REMOVE EMPTY FILTER VALUES
    |--------------------------------------------------------------------------
    */

    const cleanParams =
        Object.fromEntries(

            Object.entries(
                params || {}
            ).filter(
                ([, value]) => {

                    return (
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                    );

                }
            )

        );


    /*
    |--------------------------------------------------------------------------
    | API REQUEST
    |--------------------------------------------------------------------------
    */

    return api.get(
        "/journey-plans",
        {
            params: {

                page:
                    Number(page) || 1,

                limit:
                    Number(limit) || 10,

                ...cleanParams,

            },
        }
    );

};


// ============================================================
// CREATE
// ============================================================

export const createJourneyPlan = (
    data
) => {

    return api.post(
        "/journey-plans",
        data
    );

};


// ============================================================
// GET SINGLE
// ============================================================

export const getJourneyPlan = (
    id
) => {

    return api.get(
        `/journey-plans/${id}`
    );

};


// ============================================================
// UPDATE
// ============================================================

export const updateJourneyPlan = (
    id,
    data
) => {

    return api.patch(
        `/journey-plans/${id}`,
        data
    );

};


// ============================================================
// DELETE / CANCEL
// ============================================================

export const deleteJourneyPlan = (
    id
) => {

    return api.delete(
        `/journey-plans/${id}`
    );

};


// ============================================================
// SUBMIT
// ============================================================

export const submitJourneyPlan = (
    id
) => {

    return api.post(
        `/journey-plans/${id}/submit`
    );

};


// ============================================================
// APPROVE
// ============================================================

export const approveJourneyPlan = (
    id,
    data = {}
) => {

    return api.post(
        `/journey-plans/${id}/approve`,
        data
    );

};


// ============================================================
// REJECT
// ============================================================

export const rejectJourneyPlan = (
    id,
    data = {}
) => {

    return api.post(
        `/journey-plans/${id}/reject`,
        data
    );

};


// ============================================================
// TODAY JOURNEY PLAN
// ============================================================

export const getTodayJourneyPlan = (
    employeeId
) => {

    return api.get(
        `/journey-plans/today/${employeeId}`
    );

};


// ============================================================
// IMPORT JOURNEY PLANS (EXCEL / CSV)
// ============================================================

export const importJourneyPlans = (formData) => {
    return api.post(
        "/journey-plans/import",
        formData
    );
};